import { render, staticRenderFns } from "./ShipmentTrackingDetails.vue?vue&type=template&id=03fcf2c5&scoped=true"
import script from "./ShipmentTrackingDetails.vue?vue&type=script&lang=ts"
export * from "./ShipmentTrackingDetails.vue?vue&type=script&lang=ts"
import style0 from "./ShipmentTrackingDetails.vue?vue&type=style&index=0&id=03fcf2c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fcf2c5",
  null
  
)

export default component.exports